(function($,sr){
// debouncing function from John Hann
// http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
    var debounce = function (func, threshold, execAsap) {
        var timeout;
        return function debounced () {
            var obj = this, args = arguments;
            function delayed () {
                if (!execAsap)
                    func.apply(obj, args);
                timeout = null;
            };
            if (timeout)
                clearTimeout(timeout);
            else if (execAsap)
                func.apply(obj, args);
            timeout = setTimeout(delayed, threshold || 500);
        };
    }
// smartresize
    jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };
})(jQuery,'smartresize');

$(window).smartresize(function() {
    $('.interactive-table-body').mCustomScrollbar("destroy");
    $('.interactive-table-body').mCustomScrollbar({
        axis : "x",
        setLeft: "80000px",
        advanced:{
            updateOnContentResize: true
        },
        callbacks:{
            whileScrolling:function(){
                if(this.mcs.leftPct < 98){
                    $('.bottom__mobile-message').addClass('animated lightSpeedOut');
                }
            },
            alwaysTriggerOffsets: true
        }
    });
});


;(function ($) {
    $(document).ready(function () {
        var container = $('[animationInserted]');
        var element = $('[animateMe]');
        container.find(element).each(function () {
            var animationMethod = $(this).data('animationmethod');
            $(this).addClass(animationMethod + " animated");
        });
        var $wayPointObject = $('.wp');
        $wayPointObject.waypoint(function (direction) {
            if (direction == 'down') {
                animated(this);
            }
        }, {
            offset: '80%'
        });
        function animated(ele) {
            var animationMethod = $(ele.element).data('animationmethod');
            $(ele.element).addClass(animationMethod + " animated");
        }
        $('.home__final-shot').on('click', function () {
            $('.header__menu-button').trigger('click')
        });
        $('.mobileindex_01').height($(window).height());
        fullContainerWidth();
    });
    $(window).on('load',function() {
        $('.interactive-table-body').mCustomScrollbar({
            axis : "x",
            //setHeight: "90%",
            setLeft: "80000px",
            advanced:{
                updateOnContentResize: true
            },
            callbacks:{
                whileScrolling:function(){
                    if(this.mcs.leftPct < 98){
                        $('.bottom__mobile-message').addClass('animated lightSpeedOut');
                    }
                },
                alwaysTriggerOffsets: true
            }
        });
    });

    $(window).on('resize',function() {
        fullContainerWidth();
        //console.log(totalWidth);
    });

    function fullContainerWidth(){
        $('.mobileindex_01').height($(window).height());
        $('.mobileindex_01').width($(window).width());
        var totalWidth = 0;
        $('.mobileindex__holder > div').each(function(){
            var indWidth = $(this).outerWidth();
            totalWidth = indWidth + totalWidth;
        });
        $('.mobileindex__holder').width(totalWidth+50);
        //console.log('from FCW');
    }

})(jQuery);

